import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Grid,
  InputAdornment,
  IconButton,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

const DiscountVoucher = ({ applyDiscount, voucher, setVoucher }) => {
  const [voucherCode, setVoucherCode] = useState(voucher?.offer_code || "");

  useEffect(() => {
    if (voucher?.offer_code) {
      setVoucherCode(voucher.offer_code);
    }
  }, [voucher]);

  const handleApplyVoucher = () => {
    applyDiscount(voucherCode);
  };

  const handleClearVoucher = () => {
    setVoucherCode("");
    applyDiscount("");
    setVoucher();
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Discount Voucher"
          variant="outlined"
          value={voucherCode}
          sx={{ backgroundColor: "#f0f0f0" }}
          InputLabelProps={{
            shrink: voucherCode ? true : false,
          }}
          InputProps={{
            readOnly: true,
            endAdornment: voucherCode && (
              <InputAdornment position="end">
                <IconButton onClick={handleClearVoucher} edge="end">
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
    </Grid>
  );
};

export default DiscountVoucher;
